import { v4 as uuidv4 } from 'uuid';
import cogoToast from 'cogo-toast';
const { createSlice } = require('@reduxjs/toolkit');

const cartSlice = createSlice({
    name: "cart",
    initialState: {
        cartItems: []
    },
    reducers: {
        addToCart(state, action) {
            const rawProduct = action.payload;
            
            let targetDesignId = String(rawProduct.id);
            let availableQty = 0;

            if (rawProduct.designDetails && rawProduct.designDetails.length > 0) {
                const matchingDesign = rawProduct.designDetails.find(d => String(d.ItemDesignId || d.Id) === String(rawProduct.id));
                if (matchingDesign) {
                    targetDesignId = String(matchingDesign.ItemDesignId || matchingDesign.Id);
                    availableQty = matchingDesign.AvailableQty !== undefined ? matchingDesign.AvailableQty : 0;
                } else {
                    targetDesignId = String(rawProduct.designDetails[0].ItemDesignId || rawProduct.designDetails[0].Id || rawProduct.id);
                    availableQty = rawProduct.designDetails[0].AvailableQty !== undefined ? rawProduct.designDetails[0].AvailableQty : 0;
                }
            } else if (rawProduct.stock !== undefined) {
                availableQty = rawProduct.stock;
            }

            const product = {
                ...rawProduct,
                id: targetDesignId
            };

            const maxAllowed = Math.max(0, availableQty);

            if(!product.variation){
                const cartItem = state.cartItems.find(
                    item => String(item.id) === String(targetDesignId) ||
                            String(item.id) === String(rawProduct.id) ||
                            (item.designDetails && item.designDetails.length > 0 && String(item.designDetails[0].ItemDesignId || item.designDetails[0].Id) === String(targetDesignId))
                );
                const currentQty = cartItem ? cartItem.quantity : 0;
                const addQty = product.quantity ? product.quantity : 1;

                if (currentQty + addQty > maxAllowed) {
                    cogoToast.error("No more stock available.", {position: "bottom-left"});
                    return;
                }

                if(!cartItem){
                    state.cartItems.push({
                        ...product,
                        quantity: addQty,
                        cartItemId: uuidv4()
                    });
                } else {
                    state.cartItems = state.cartItems.map(item => {
                        if(item.cartItemId === cartItem.cartItemId){
                            return {
                                ...item,
                                id: targetDesignId,
                                quantity: item.quantity + addQty
                            }
                        }
                        return item;
                    })
                }

            } else {
                const cartItem = state.cartItems.find(
                    item =>
                        (String(item.id) === String(targetDesignId) || String(item.id) === String(rawProduct.id)) &&
                        product.selectedProductColor &&
                        product.selectedProductColor === item.selectedProductColor &&
                        product.selectedProductSize &&
                        product.selectedProductSize === item.selectedProductSize &&
                        (product.cartItemId ? product.cartItemId === item.cartItemId : true)
                );
                const currentQty = cartItem ? cartItem.quantity : 0;
                const addQty = product.quantity ? product.quantity : 1;

                if (currentQty + addQty > maxAllowed) {
                    cogoToast.error("No more stock available.", {position: "bottom-left"});
                    return;
                }

                if(!cartItem){
                    state.cartItems.push({
                        ...product,
                        quantity: addQty,
                        cartItemId: uuidv4()
                    });
                } else if (cartItem !== undefined && (cartItem.selectedProductColor !== product.selectedProductColor || cartItem.selectedProductSize !== product.selectedProductSize)) {
                    state.cartItems = [
                        ...state.cartItems,
                        {
                            ...product,
                            quantity: addQty,
                            cartItemId: uuidv4()
                        }
                    ]
                } else {
                    state.cartItems = state.cartItems.map(item => {
                        if(item.cartItemId === cartItem.cartItemId){
                            return {
                                ...item,
                                id: targetDesignId,
                                quantity: item.quantity + addQty,
                                selectedProductColor: product.selectedProductColor,
                                selectedProductSize: product.selectedProductSize
                            }
                        }
                        return item;
                    });
                }
            }

            cogoToast.success("Added To Cart", {position: "bottom-left"});
        },
        deleteFromCart(state, action) {
            state.cartItems = state.cartItems.filter(item => item.cartItemId !== action.payload);
            cogoToast.error("Removed From Cart", {position: "bottom-left"});
        },
        decreaseQuantity(state, action){
            const product = action.payload;
            if (product.quantity === 1) {
                state.cartItems = state.cartItems.filter(item => item.cartItemId !== product.cartItemId);
                cogoToast.error("Removed From Cart", {position: "bottom-left"});
            } else {
                state.cartItems = state.cartItems.map(item =>
                    item.cartItemId === product.cartItemId
                        ? { ...item, quantity: item.quantity - 1 }
                        : item
                );
                cogoToast.warn("Item Decremented From Cart", {position: "bottom-left"});
            }
        },
        deleteAllFromCart(state){
            state.cartItems = []
        },
        setCartItems(state, action) {
            state.cartItems = action.payload;
        }
    },
});

export const { addToCart: _addToCart, deleteFromCart, decreaseQuantity, deleteAllFromCart, setCartItems } = cartSlice.actions;

export const addToCart = (product) => (dispatch) => {
    dispatch(_addToCart(product));
};

export default cartSlice.reducer;
